const observerInstances = new Map();

export const getObserver = (key, callback, options = {}) => {
    const cacheKey = key + JSON.stringify(options);
    if (observerInstances.has(cacheKey)) {
        return observerInstances.get(cacheKey);
    }
    const observer = new IntersectionObserver(callback, options);
    observerInstances.set(cacheKey, observer);
    return observer;
};

export const cleanupObservers = (key) => {
    if (!key) {
        observerInstances.forEach(o => o.disconnect());
        observerInstances.clear();
        return;
    }
    [...observerInstances].filter(([k]) => k.startsWith(key))
        .forEach(([k, o]) => {
            o.disconnect();
            observerInstances.delete(k);
        });
};